import React, { useEffect, useState } from 'react';
import { fetchInspections, Inspection } from '../../services/inspectionsApi';
import { btnSmall, StatusBadge } from './common';
import { ui } from '../../styles/shared';
import { fmtDate } from '../../utils/format';

/**
 * En rond i panelen ovanför flikarna: alla platser med status, och en knapp per plats
 * som öppnar den kontrollen. Används när man klickar på en rond i årshjulet eller historiken.
 */
interface Props {
    roundId: number;
    /** Räknas upp av föräldern när något sparats, så listan hämtas igen. */
    refreshKey: number;
    onOpen: (id: number) => Promise<void>;
    onClose: () => void;
    onError: (msg: string) => void;
}

const RoundPanel: React.FC<Props> = ({ roundId, refreshKey, onOpen, onClose, onError }) => {
    const [items, setItems] = useState<Inspection[]>([]);

    useEffect(() => {
        fetchInspections({ status: 'all', round_id: roundId })
            .then(rows => setItems([...rows].sort((a, b) => (a.zone_name ?? '').localeCompare(b.zone_name ?? '', 'sv'))))
            .catch(e => onError(e.message));
    }, [roundId, refreshKey, onError]);

    const head = items[0];
    // Klar = gjord eller överhoppad; åtgärd som väntar räknas inte.
    const done = items.filter(i => i.status === 'done' || i.status === 'skipped').length;
    const isOpen = (i: Inspection) => i.status === 'pending' || i.status === 'overdue';

    return (
        <div style={{ ...ui.card, borderColor: '#0f3460', padding: 20 }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 10, flexWrap: 'wrap' }}>
                <div>
                    <h2 style={{ margin: '0 0 4px' }}>{head ? (head.schedule_name ?? head.template_name) : 'Rond'}</h2>
                    <div style={{ fontSize: 13, color: '#666' }}>
                        Rond · {items.length} platser · senast {head ? fmtDate(head.due_date) : '–'} · <b>{done} av {items.length}</b> klara
                    </div>
                </div>
                <button onClick={onClose} style={btnSmall('#6c757d')}>Stäng</button>
            </div>
            <div style={{ overflowX: 'auto', marginTop: 12 }}>
                <table style={{ width: '100%', borderCollapse: 'collapse', background: 'white' }}>
                    <thead><tr><th style={ui.th}>Plats</th><th style={ui.th}>Status</th><th style={ui.th}>Av</th><th style={ui.th}></th></tr></thead>
                    <tbody>
                        {items.map(i => (
                            <tr key={i.id} style={{ background: i.status === 'overdue' ? '#fff5f5' : undefined }}>
                                <td style={ui.td}><b>{i.zone_name ?? 'Plats'}</b>{i.has_deviation && <div style={{ fontSize: 12, color: '#b02a37' }}>avvikelse</div>}</td>
                                <td style={ui.td}><StatusBadge i={i} /></td>
                                <td style={ui.td}>{isOpen(i) ? (i.started_by_name ?? '–') : (i.completed_by_name ?? '–')}</td>
                                <td style={{ ...ui.td, textAlign: 'right' }}>
                                    <button onClick={() => onOpen(i.id)} style={btnSmall(isOpen(i) ? '#0f3460' : '#e8f0fe', isOpen(i) ? 'white' : '#1a4aa6')}>
                                        {isOpen(i) ? (i.has_draft ? 'Fortsätt' : 'Gör kontrollen') : 'Visa'}
                                    </button>
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

export default RoundPanel;
